import React from 'react';
import './ChallengePopup.css'; // Add your styles here
import { FaRocket, FaLightbulb } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import Navigation from 'support/navigation'

const ChooseChallenge = ({ onClose }) => {
  const history = useHistory();

  const handleRedirect = (path) => {
    history.push(path); // Navigate to the route
    // onClose(); // Close the popup
  };


  
  return (
    // <div className="popup-overlay">
      <div className="popup-container">
        <h2>Choose Your Challenge</h2>
        <p>Pick a challenge to begin your journey.</p>
        <div className="challenge-options">
          <div
            role="button"
            tabIndex={0}
            className="challenge-card nova" 
            onClick={() => handleRedirect(Navigation.navigateToNovaChallenge())}
            onKeyDown= {(e) => (e.key === 'Enter' || e.key === ' ') &&  handleRedirect(Navigation.navigateToNovaChallenge())}
          >
            <FaRocket size={40} />
            <h3>Nova Challenge</h3>
            <p>Explore new frontiers with Nova.</p>
          </div>
          <div 
           role="button"
           tabIndex={0}
            className="challenge-card innovate" 
            onKeyDown= {(e) => (e.key === 'Enter' || e.key === ' ') &&  handleRedirect(Navigation.navigateToInnovateChallenge())}
            onClick={() => handleRedirect(Navigation.navigateToInnovateChallenge())}>
            <FaLightbulb size={40} />
            <h3>Innovate Challenge</h3>
            <p>Unleash your creativity with Innovate.</p>
          </div>
        </div>
        {/* <button className="close-btn" onClick={onClose}>Close</button> */}
      </div>
    // </div>
  );
};

export default ChooseChallenge;
